export default __webpack_public_path__ + "media/mrwa-logo.a580a4b3.png";